import { AppData } from '../types'
import { formatDateTime } from './dateFormat'

export const downloadJSON = (data: AppData) => {
  const filename = `zapiis-export-${new Date().toISOString().split('T')[0]}.json`
  const jsonStr = JSON.stringify(data, null, 2)
  const blob = new Blob([jsonStr], { type: 'application/json' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export const generateLawyerPackage = (data: AppData) => {
  const { profile, incidents, people, evidence, checkins, intakeAnswers } = data

  let content = `ZAPIIS LEGAL DOCUMENTATION PACKAGE
Generated: ${formatDateTime(new Date().toISOString())}
----------------------------------------

CLIENT PROFILE
Name: ${profile.name || 'Not provided'}
Email: ${profile.email || 'Not provided'}
Phone: ${profile.phone || 'Not provided'}
Case Description: ${profile.caseDescription || 'Not provided'}

----------------------------------------

INTAKE SUMMARY
Outcome Sought: ${intakeAnswers.outcome || 'N/A'}
Timeline Context: ${intakeAnswers.timeline || 'N/A'}
Background: ${intakeAnswers.context || 'N/A'}
Reporting History: ${intakeAnswers.reporting || 'N/A'}
Personal Impact: ${intakeAnswers.impact || 'N/A'}
Witnesses: ${intakeAnswers.witnesses || 'N/A'}
Additional Info: ${intakeAnswers.additional || 'N/A'}

----------------------------------------

INCIDENT LOG (${incidents.length} records)
`

  incidents
    .sort(
      (a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime(),
    )
    .forEach((inc) => {
      content += `
[${formatDateTime(inc.datetime)}] - ${inc.title}
Category: ${inc.category}
Location: ${inc.location || 'Not specified'}
Description: ${inc.description}
People Involved: ${
        inc.peopleIds
          .map((id) => people.find((p) => p.id === id)?.name)
          .filter(Boolean)
          .join(', ') || 'None listed'
      }
`
    })

  content += `
----------------------------------------

EVIDENCE INVENTORY (${evidence.length} items)
`

  evidence.forEach((ev) => {
    content += `
- ${ev.fileName} (${ev.fileType})
  Uploaded: ${formatDateTime(ev.timestamp)}
  Description: ${ev.description}
`
  })

  content += `
----------------------------------------

PEOPLE INVOLVED (${people.length} records)
`

  people.forEach((p) => {
    content += `
- ${p.name} (${p.role})
  Contact: ${p.contact || 'N/A'}
  Notes: ${p.notes || 'N/A'}
`
  })

  content += `
----------------------------------------

HEALTH & IMPACT CHECK-INS (${checkins.length} records)
`

  checkins
    .sort(
      (a, b) =>
        new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
    )
    .forEach((c) => {
      content += `
[${formatDateTime(c.timestamp)}] Mood: ${c.mood}
Symptoms: ${c.symptoms || 'None'}
Emotional Impact: ${c.emotionalImpact || 'None'}
Notes: ${c.notes || 'None'}
`
    })

  content += `
----------------------------------------
DISCLAIMER: This document was generated by Zapiis. 
It serves as a documentation aid and does not constitute legal advice.
`

  const filename = `zapiis-lawyer-package-${new Date().toISOString().split('T')[0]}.txt`
  const blob = new Blob([content], { type: 'text/plain' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
